export default "__VITE_ASSET__Cq$kFkNS__"